import $ from 'jquery';
import { dangerouslyShowAlertMessage } from 'javascripts/messages';
import { isLocalStorageSupported } from 'javascripts/utils';
import Turbolinks from 'javascripts/turbolinks';
import bindAdvancedForm from './form';
import iframeRefresher from '../iframe_refresher.js';
import { setupFilters } from './filters.js';

// Replace the back button with a link based on what was passed in the
// parameters when this page first loaded.
//
// This does not use the history API because we only care to remember some of
// the pages, and we also need access to the urls and titles from all the
// entries so we can display them.
function setupBackButton() {
  // sometimes localStorage is disabled or not available
  if (!isLocalStorageSupported()) {
    return;
  }

  let stack = localStorage.getItem('breadcrumbStack');

  if (!stack) {
    return;
  }

  stack = JSON.parse(stack);

  const backLink = $('[data-profile-back-button]');

  // Profile back button goes back to the last page
  if (backLink.length > 0) {
    const entry = stack[1] || stack[0];

    const placeholder = backLink.find('[data-generic-back]');
    placeholder.addClass('hide');

    const newLink = backLink.find('[data-specific-back]');

    const content = newLink.find('span');
    let text = content.html();
    text = text.replace(/__PAGE__/, entry.lcaseName || entry.name);
    content.text(text);
    newLink.attr('href', entry.url).removeClass('hide');
  }

  const homeBreadcrumb = $('[data-dynamic-back-breadcrumb]');

  // Idea show breadcrumbs show the last two pages
  if (homeBreadcrumb.length > 0 && !homeBreadcrumb.attr('data-mutated')) {
    const entry = stack[0];
    // Remove this part of the breadcrumb if it is redundant
    if (
      homeBreadcrumb.siblings().eq(0).find('a').attr('href') ===
      new URL(entry.url).pathname + new URL(entry.url).search
    ) {
      homeBreadcrumb.remove();
    } else {
      homeBreadcrumb
        .find('a')
        .attr('href', entry.url)
        .text(entry.name)
        .attr('data-mutated', true);
    }
  }
}

// Reset the history stack to just this page
window.pushIndexBreadcrumb = (pageName, lcaseName) => {
  // sometimes localStorage is disabled or not available
  if (!isLocalStorageSupported()) {
    return;
  }

  localStorage.setItem(
    'breadcrumbStack',
    JSON.stringify([
      { url: document.location.href, name: pageName, lcaseName: lcaseName },
    ])
  );
};

// Push the detail page on top of the index breadcrumb (if there is one)
window.pushDetailBreadcrumb = pageName => {
  // sometimes localStorage is disabled or not available
  if (!isLocalStorageSupported()) {
    return;
  }

  let stack = localStorage.getItem('breadcrumbStack');
  const url = document.location.href;

  if (stack) {
    stack = JSON.parse(stack);
    stack[1] = { url: url, name: pageName };
  } else {
    stack = [{ url: url, name: pageName }];
  }

  localStorage.setItem('breadcrumbStack', JSON.stringify(stack));
};

// Simple nav tabs for displaying content areas based on clicking on tabs
function setupNavTabs() {
  $('.nav-tabs__button').on('click', event => {
    const contentName = $(event.currentTarget).attr('data-tab-for');

    $('.nav-tabs__tab--active').removeClass('nav-tabs__tab--active');
    $(event.currentTarget)
      .closest('.nav-tabs__tab')
      .addClass('nav-tabs__tab--active');

    $('[data-tab-content]').removeClass('tab-pane--active');
    $(`[data-tab-content=${contentName}]`).addClass('tab-pane--active');
  });
}

function showClearSearchButton() {
  if ($('#query').length > 0 && $('#query').val().length > 0) {
    $('.clear-button').removeClass('hide');
  }
}

function setupShowIdeaDetailsButton() {
  $('#show-all-idea-stats')
    .off('click.show-details')
    .on('click.show-details', () => {
      $('.idea-sidebar').addClass('idea-sidebar--all-details');
    });
}

function setupIdeaLoadingSpinner() {
  $('.list-ideas .idea--is-loading')
    .removeClass('idea--is-loading')
    .find('.fa-spinner')
    .remove();

  $('.list-ideas .idea-link').rebind('click.loading-indicator', event => {
    $('.list-ideas .idea--is-loading')
      .removeClass('idea--is-loading')
      .find('.fa-spinner')
      .remove();

    // Don't show the spinner if the user is opening the window in a new tab
    if (event.metaKey || event.ctrlKey) {
      return;
    }

    $(event.currentTarget).closest('.idea').addClass('idea--is-loading');
    $(event.currentTarget)
      .closest('.idea-details')
      .prepend('<i class="fa-regular fa-spinner fa-spin fa-2x"></i>');
  });
}

function setupIdeaFormHandlers() {
  ['form#new_ideas_idea', 'form[id^=edit_ideas_idea]'].forEach(formSelector => {
    const $form = $(formSelector);

    if ($form.length === 0) {
      return;
    }

    $form.on('ajax:error', (event, data) => {
      const message = data?.responseJSON?.message;

      if (message) {
        dangerouslyShowAlertMessage(message);
      }
    });

    // If we have form elements for the portal, bind up rule handling.
    if (window.formElements) {
      bindAdvancedForm(
        formSelector,
        window.formElements,
        window.formTranslations,
        window.formVisitedSectionIds
      );
    }
  });
}

window.iframeRefresher = iframeRefresher;

$(document).on(Turbolinks.EVENTS.BEFORE_UNLOAD, event => {
  setupFilters(event.originalEvent.data.newBody);
});

$(document).on(Turbolinks.EVENTS.CHANGE, () => {
  setupNavTabs();
  setupBackButton();
  showClearSearchButton();
  setupIdeaLoadingSpinner();
  setupShowIdeaDetailsButton();
  setupIdeaFormHandlers();
  setupFilters(document.body);
});

$(() => {
  $('.login-popover').on('hide.bs.popover', () => {
    $('.login-link').removeClass('open');
  });
  $('.login-popover').on('show.bs.popover', () => {
    $('.login-link').removeClass('open');
  });
  $(document).on('click', '.login-link.dropdown-with-caret', event => {
    const popover = $(event.target).next('.login-popover');
    const loginLink = $(event.target);

    if (popover.hasClass('active')) {
      popover.removeClass('active');
      loginLink.attr('aria-expanded', 'false');
      $(event.currentTarget).blur();
    } else {
      $('.popover.active').removeClass('active');
      popover.addClass('active');
      loginLink.attr('aria-expanded', 'true');
      $('.popover.active #ideas_idea_user_email').focus();
    }
    return false;
  });

  $(document).on('click', '.idea-submitted__close-window', event => {
    // It is not possible to specify an origin for the post message here as the parent is
    // the customers site which is hosting the widget. There is no sensitive data being
    // transmitted here only a generic eventName.
    if (window.parent) {
      window.parent.postMessage({ eventName: 'ahaFeedback:hide' }, '*');
    }
  });

  // a11y Hide category hint popover on esc
  $(document).on('keydown', event => {
    if (event.key === 'Escape') {
      $('.category-hint').popover('hide');
    }
  });

  $(document).on('click', '.idea-portal-section__grid__card', event => {
    window.location = $(event.currentTarget).data('location');
  });
});

window.setupIdeaCreateNewTabSignin = () => {
  // This is called from _new_form_contents right after the submit buttons
  // But sometimes the buttons are rendered in _new_form_full_page so we want to wait for them to be rendered
  $(function () {
    $('#save-button').toggleClass('hidden');
  });

  const localStorageSupported = isLocalStorageSupported();

  $(document).on('click', '#signin-portal-aha-create-idea', event => {
    const href = $(event.target).closest('a[href]').attr('href');
    window.open(href, '_blank', 'noopener,noreferrer');
    event.preventDefault();

    // if we don't have localStorage support, just redisplay the "ADD IDEA" button
    // in 5s after clicking the signin button
    if (!localStorageSupported)
      setTimeout(() => {
        $('#save-button').toggleClass('hidden');
      }, 5000);
  });

  if (localStorageSupported) {
    localStorage.setItem('idea-create-session-established', 'false');

    window.addEventListener('storage', event => {
      if (
        event.key === 'idea-create-session-established' &&
        event.newValue === 'true' &&
        event.oldValue !== 'true'
      ) {
        $('#save-button').toggleClass('hidden');
        $('#signin-portal-aha-create-idea').toggleClass('hidden');
      }
    });
  }
};
